import { Status } from "../../../../../../../utils/enums"
import { Item } from "../../../../../../../utils/types/generals"
import { ItemMenu } from "../../../../../../questionnaire/pages/main/typing/types"
import { MenuOptionFileManager } from "../../../../../utils/enums/menu"
import { TypeFileEnum, TypeFileTextEnum } from "../enums/enums"

const menuItems: ItemMenu[] = [
  {
    label: 'Ver detalle',
    value: MenuOptionFileManager.SEE_DETAIL_FILE,
  },
  {
    label: 'Activar',
    value: MenuOptionFileManager.ACTIVATE_FILE,
  },
  {
    label: 'Desactivar',
    value: MenuOptionFileManager.DESACTIVATE_FILE,
  },
  {
    label: 'Editar archivo',
    value: MenuOptionFileManager.EDIT_FILE,
  },
  {
    label: 'Eliminar archivo',
    value: MenuOptionFileManager.DELETE_FILE,
  }
]

const formatFilterMain = {
  search: 'search',
  from: 'date_init',
  creationDate: 'date_init',
  to: "date_end",
  fileType: "file_type",
  percentage: "range_size",
  user: "user_ids",
  area: "areas_ids",
  department: "departments_ids",
  status: "status_ids",
}

const formatFilterAdd = {
  search: 'search',
  from: 'date_start',
  to: 'date_end',
  fileType: "file_type",
}

const formatFilterList = {
  search: 'search',
  area:'areas_ids',
  department: 'departments_ids',
  userTypeId: 'user_types_id',
  roles: 'role_ids'
}

const fileType: Item[] = [
  {
    label: 'PDF',
    value: TypeFileEnum.PDF,
  },
  {
    label: 'Word',
    value: TypeFileEnum.WORD,
  },
  {
    label: 'CSV',
    value: TypeFileEnum.CSV,
  },
  {
    label: 'Excel',
    value: TypeFileEnum.EXCEL,
  },
  {
    label: 'PowerPoint',
    value: TypeFileEnum.POWERPOINT,
  },
  {
    label: 'TXT',
    value: TypeFileEnum.TXT,
  },
  {
    label: 'Imagen',
    value: TypeFileEnum.IMAGE,
  },
  {
    label: 'Video',
    value: TypeFileEnum.VIDEO,
  }
]

const fileTypeText: Item[] = [
  {
    label: 'PDF',
    value: TypeFileTextEnum.PDF,
  },
  {
    label: 'Word',
    value: TypeFileTextEnum.WORD,
  },
  {
    label: 'CSV',
    value: TypeFileTextEnum.CSV,
  },
  {
    label: 'Excel',
    value: TypeFileTextEnum.EXCEL,
  },
  {
    label: 'PowerPoint',
    value: TypeFileTextEnum.POWERPOINT,
  },
  {
    label: 'TXT',
    value: TypeFileTextEnum.TXT,
  },
  {
    label: 'Imagen',
    value: TypeFileTextEnum.IMAGE,
  },
  {
    label: 'Video',
    value: TypeFileTextEnum.VIDEO,
  }
]

const menuListFiles: Record<string, number[]> = {
  [Status.ACTIVE]: [1, 3, 4, 5],
  [Status.INACTIVE]: [1, 2, 4, 5],
}

export { menuItems, formatFilterMain, fileType, formatFilterList, menuListFiles, fileTypeText, formatFilterAdd }